export const listStudios = `query ListStudios(
    $filter: ModelStudioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudios(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        StudioName
        images
        studioLocation
        pricePerHour
        image
        description
        userID
        studioTypes
        tagValues
        studioSize
        numberOfPeople
        city
        postcode
        cancellationPolicy
        houseRules {
          smokingAllowed
          alcoholAllowed
          foodAllowed
          equipmentChangesAllowed
          pyrotechnicsAllowed
          glitterConfettiAllowed
          adultContentAllowed
          fogMachineAllowed
          customRules
        }
        User {
          id
          firstName
          lastName
          profilePicture
          numberOfStudios
          __typename
        }
        country
        approxLatitude
        approxLongitude
        locationLabel
        locationPrecision
        minNumberOfHours
        amenities
        tags {
          nextToken
          __typename
        }
        equipment {
          nextToken
          __typename
        }
        availabilities {
          nextToken
          __typename
        }
        bookings {
          nextToken
          __typename
        }
        blockedTimes {
          nextToken
          __typename
        }
        wishListStudios {
          nextToken
          __typename
        }
        chatRooms {
          nextToken
          __typename
        }
        status
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getStudio = `query GetStudio($id: ID!) {
  getStudio(id: $id) {
    id
    StudioName
    images
    studioLocation
    pricePerHour
    image
    description
    userID
    studioTypes
    tagValues
    studioSize
    numberOfPeople
    city
    postcode
    cancellationPolicy
    houseRules {
      smokingAllowed
      alcoholAllowed
      foodAllowed
      equipmentChangesAllowed
      pyrotechnicsAllowed
      glitterConfettiAllowed
      adultContentAllowed
      fogMachineAllowed
      customRules
    }
    User {
      id
      firstName
      lastName
      profilePicture
      numberOfStudios
      stripeConnectAccountId
      stripeChargesEnabled
      stripePayoutsEnabled
      stripeOnboardingComplete
      Studios {
        nextToken
        __typename
      }
      bookings {
        nextToken
        __typename
      }
      wishLists {
        nextToken
        __typename
      }
      chatRooms {
        nextToken
        __typename
      }
      userChatRooms {
        nextToken
        __typename
      }
      __typename
    }
    country
    approxLatitude
    approxLongitude
    locationLabel
    locationPrecision
    minNumberOfHours
    pricingMode
    tieredPricing {
      minPersons
      maxPersons
      pricePerHour
    }
    packages {
      id
      name
      durationHours
      prices {
        minPersons
        maxPersons
        price
      }
    }
    discountRules {
      minHours
      discountType
      discountValue
    }
    weekendSurcharge {
      saturdayEnabled
      saturdaySurchargeType
      saturdaySurchargeValue
      sundayEnabled
      sundaySurchargeType
      sundaySurchargeValue
    }
    extraFees {
      id
      name
      amount
    }
    productionAreaSize
    amenities
    tags {
      items {
        id
        studioId
        tagId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    equipment {
      items {
        id
        studioID
        category
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    availabilities {
      items {
        id
        studioID
        dayOfWeek
        startTime
        endTime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    bookings {
      items {
        id
        studioID
        userID
        startDateTime
        endDateTime
        totalPrice
        status
        projectName
        companyName
        projectDescription
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    blockedTimes {
      items {
        id
        studioID
        title
        startDateTime
        endDateTime
        isFullDay
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    wishListStudios {
      items {
        id
        wishListID
        studioID
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
      chatRooms {
        items {
          id
          name
          image
          lastMessageAt
          studioID
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      status
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const listStudiosLocationPrice = `query ListStudiosLocationPrice(
    $filter: ModelStudioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudios(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        pricePerHour
        approxLatitude
        approxLongitude
        locationLabel
        locationPrecision
        status
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listStudiosSimplified = `query ListStudiosSimplified(
    $filter: ModelStudioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStudios(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        StudioName
        images
        studioLocation
        pricePerHour
        studioTypes
        tagValues
        numberOfPeople
        city
        approxLatitude
        approxLongitude
        locationLabel
        locationPrecision
        minNumberOfHours
        status
        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const getStudioMapInfo = `query GetStudioMapInfo($id: ID!) {
  getStudio(id: $id) {
    id
    StudioName
    images
    city
    pricePerHour
    pricingMode
    tieredPricing {
      minPersons
      maxPersons
      pricePerHour
    }
    packages {
      id
      name
      durationHours
      prices {
        minPersons
        maxPersons
        price
      }
    }
    __typename
  }
}
`;
